import register from '../register';

register( 'technology-page', () => {

  let moreBtns = document.querySelectorAll('.expand-more');

  moreBtns.forEach( btn => {
    let parent = btn.closest('.shadow-card__subsection');

    btn.addEventListener( 'mouseenter', () => {
      parent.classList.add('is-hovered');
    });

    btn.addEventListener( 'mouseleave', () => {
      parent.classList.remove('is-hovered');
    });

  });

});

export default undefined;
